import CustomComponent from 'CustomModules/CustomPackage/components/CustomComponent/CustomComponent'

export const Components = [
  {name: 'custom-component', component: CustomComponent}
]



// WEBPACK FOOTER //
// ./src/customization/CustomPackage/components.js